import React, { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  Typography,
} from "@mui/material";
import TypeWritterLoader from "./TypeWritterLoader";
import {
  downlaodGRNDocument,
  getGRNlineItemsByReceiptId,
} from "../services/dataService";
import BasicTable from "./table/BasicTable";
import { GRN_DETAILS } from "../columns/columns";
import { useParams } from "react-router-dom";

function GRNViewModal({ handleClose, loader, purchaseOrder }) {
  const { ReceiptId } = useParams();
  const [error, setError] = useState(false);
  const [grnDetails, setGRNDetails] = useState([]);
  const [grnDocument, setGrnDocument] = useState("");

  useEffect(() => {
    const getGRNDetails = async (grnID) => {
      try {
        setError(false);
        const response = await getGRNlineItemsByReceiptId(grnID);
        setGRNDetails(response.data);

        const documentresponse = await downlaodGRNDocument(
          response.data[0].ReceiptNo
        );
        setGrnDocument(documentresponse.data);
      } catch {}
    };

    if (ReceiptId === "list") {
      getGRNDetails(purchaseOrder?.ReceiptID);
    } else {
      getGRNDetails(ReceiptId);
    }

    return () => {
      setGrnDocument("");
      setGRNDetails([]);
      setError(false);
    };
    // eslint-disable-next-line
  }, [purchaseOrder]);

  const getPopUpSize = () => {
    if (loader) return "sm";
    if (!loader) return "lg";
    else return "lg";
  };

  return (
    <>
      {Boolean(grnDetails.length) && (
        <Dialog
          fullWidth
          maxWidth={getPopUpSize()}
          open={Boolean(grnDetails.length)}
          onClose={handleClose}
        >
          <DialogContent>
            {loader && <TypeWritterLoader status={error} />}
            {!loader && (
              <Grid container>
                <Grid
                  item
                  lg={8}
                  md={6}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-around",
                  }}
                >
                  {grnDocument ? (
                    <iframe
                      src={grnDocument}
                      title="invoice"
                      style={{
                        minWidth: "730px",
                        minHeight: "820px",
                        border: "none",
                        borderRadius: "4px",
                      }}
                      allowFullScreen
                    />
                  ) : (
                    <TypeWritterLoader status={true} />
                  )}
                </Grid>
                <Grid item lg={4} md={6}>
                  <Typography omponent="h2" marginBottom={2} variant="h4">
                    {purchaseOrder ? `#${purchaseOrder.ReceiptNo}` : " "}
                  </Typography>
                  <BasicTable columns={GRN_DETAILS} data={grnDetails} />
                </Grid>
              </Grid>
            )}
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                handleClose();
                setGRNDetails([]);
              }}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
}

export default GRNViewModal;
